import { PlatformClient as BaseClient } from '../client'

export default class Client {
    constructor() {
        this.client = new BaseClient()

        this.client.http.interceptors.response.use((resp) => {
            return resp
          }, (error) => {
            if (error.response !== undefined) {
              if (error.response.status == 401) {
                window.location = "/login"
              } else if (error.response.status == 200) {
                return error.response
              } else {
                return Promise.reject(error)
              }
            }
          })
          
          this.client.http.interceptors.request.use(function(config) {
            config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
            config.headers["X-Workspace-Uuid"] = localStorage.getItem("current_workspace_uuid")
            
            if (config.headers["X-Project-Env"] === undefined)
              config.headers["X-Project-Env"] = localStorage.getItem("current_env") || "live"
          
              config.headers["Accept-Language"] = localStorage.getItem("locale") || 'en_US'
          
            return config
          }, function (error) {
            // Do something with request error
            if (error.response !== undefined) {
              if (error.response.status == 401) {
                window.location = "/login"
              } else if (error.response.status == 200) {
                return error.response
              } else {
                return Promise.reject(error)
              }
            }
          });
    }

    http() {
        return this.client.http
    }
}